const _excluded = ["muted", "stream", "style"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/web.url.js";
import "core-js/modules/web.url-search-params.js";
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
export const StreamAudio = /*#__PURE__*/React.forwardRef((props, ref) => {
  const {
      muted = true,
      stream,
      style
    } = props,
    rest = _objectWithoutProperties(props, _excluded);
  const [src, setSrc] = React.useState(undefined);
  const audio = React.useRef(null);
  React.useEffect(() => {
    if (stream) {
      try {
        if (audio.current) {
          audio.current.srcObject = stream;
        }
      } catch (error) {
        setSrc(URL.createObjectURL(stream));
      }
      return () => {
        if (src) URL.revokeObjectURL(src);
      };
    }
  }, [stream]);
  return /*#__PURE__*/React.createElement("audio", _extends({
    autoPlay: true,
    playsInline: true,
    ref: element => {
      audio.current = element;
      if (typeof ref === 'function') ref(element);else if (ref) ref.current = element;
    },
    muted: muted,
    src: src
  }, rest));
});